import axios from 'axios'

const httpClient = axios.create({
    /* --- one whole mintue for reporting --- */
    timeout: 60000
})

export default httpClient